
import TextSymbol from "@arcgis/core/symbols/TextSymbol"

export const point = {
    type: "simple-marker",
    style: "circle",
    size: 10,
    color: [255, 255, 255, 0.8],
    outline: {
      color: [211, 132, 80, 0.7],
      //size: 10
    },
  }
export const textSymbol=new TextSymbol({
    color: "white",
    haloColor: "black",
    haloSize: "2", // esri-icon-key
    text: "",
    font: {
      // autocasts as new Font()
      size: "10",
      weight: "bold",
    },
  })

  export const line = {
    type: "simple-line",
    color: "#ff0091",
    width: 2,
  }

  export const polygon = {
    type: "simple-fill",
    color:[150,150,150,0.2],
    outline:{
      color:"#ff0091",
      width:2
    }
  }

  export const selectPoint = {
    type: "simple-marker",
    style: "circle",
    size: 10,
    color: [240, 232, 17, 0.8],
    outline: {
      color: [240, 232, 17, 0.7],
      //size: 10
    },
  }

  export const selectLine = {
    type: "simple-line",
    color: [240, 232, 17, 0.7],
    width: 6,
  }

  export const selectPolygon = {
    type: "simple-fill",
    color:[150,150,150,0.2],
    outline:{
      color:[240, 232, 17, 0.7],
      width:6
    }
  }

  export const bufferPolygon = {
    type: "simple-fill",
    color: [150, 150, 150, 0.2],
    
    outline: {
      type:"simple-line",
      style:"dash",
      color: [224, 22, 107, 0.7],
      width: 2,
    },
  }

  export const selectRectangle = {
    type: "simple-fill",
    color:[150,150,150,0.2],
    outline:{
      color:[240, 232, 17, 0.7],
      width:6
    }
  }

  export const selectCircle = {
    type: "simple-fill",
    style: "circle",
    color: [240, 232, 17, 0.8],
    outline: {
      color: [240, 232, 17, 0.7],
      width:6
    }
  }